module.exports = __webpack_public_path__ + "mo/img/new-emotion-logo.98d75825.png";